import React from "react";
import DateService from "../../../services/DateService";

const AttendenceSummaryDetailModal = ({ detailData }) => {

    if (!detailData) {
        return (
            <div className="col-9 bg-white d-flex align-items-center justify-content-center">
                <h6>Select attendance record</h6>
            </div>
        );
    }

    return (
        <div className="col-9 bg-white p-3 pageTbl">
             <div className="row">
               <div className="col-md-9">
                 <div className="tab_content_wrapper">
                   <span className="content_heading">Check-In Details</span>
                 </div>
                 <table className="table table-hover table-borderless table-responsive bg-white">
                   <tbody>
                     <tr>
                       <td className="fs14 fw-normal" style={{ width: "25%" }}>
                         Check-In Time
                       </td>
                       <td className="fs14 fw500">
                         {detailData?.check_in_date &&
                          DateService.dateFormat(detailData?.check_in_date)} {detailData?.check_in_minutes}
                      </td>
                    </tr>
                    <tr>
                      <td className="fs14 fw-normal" style={{ width: "25%" }}>
                        Check-In Mode
                      </td>
                      <td className="fs14 fw500">
                        {detailData?.check_in_mode || "-"}
                      </td>
                    </tr>
                    <tr>
                      <td className="fs14 fw-normal" style={{ width: "25%" }}>
                        IP Address
                      </td>
                      <td className="fs14 fw500">
                        {detailData?.check_in_ip || "-"}
                      </td>
                    </tr>
                    <tr>
                      <td className="fs14 fw-normal" style={{ width: "25%" }}>
                        Location
                      </td>
                      <td className="fs14 fw500">
                        {detailData?.check_in_lat && detailData?.check_in_long ?
                        <a
                          href={`https://www.google.com/maps/search/${detailData?.check_in_lat},${detailData?.check_in_long}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-primary"
                        >view </a>
                        : "-"}
                      </td>
                    </tr>
                     <tr>
                      <td className="fs14 fw-normal" style={{ width: "25%" }}>
                        Updated By 
                      </td>
                      <td className="fs14 fw500">
                        {detailData?.check_in_by || "-"}
                      </td>
                    </tr>
                    <tr>
                      <td className="fs14 fw-normal" style={{ width: "25%" }}>
                        Notes
                      </td>
                      <td className="fs14 fw500">
                        {detailData?.checkin_note || "-"}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="col-md-3 text-center">
                <div style={{ height: "120px", width: "120px", margin: "0 auto" }}>
                  {detailData?.check_in_photo_link ? (
                    <img
                      src={detailData?.check_in_photo_link}
                      className="img-fluid"
                      alt="Check-In location "
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        borderRadius: "4px"
                      }}
                    />
                  ) : (
                    <img
                      src="https://t4.ftcdn.net/jpg/01/86/29/31/360_F_186293166_P4yk3uXQBDapbDFlR17ivpM6B1ux0fHG.jpg"
                      className="img-fluid"
                      alt="No check-In photo available"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        borderRadius: "4px"
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-9">
                <div className="tab_content_wrapper">
                  <span className="content_heading">Check-Out Details</span>
                </div>
                <table className="table table-hover table-borderless table-responsive bg-white">
                  <tbody>
                    <tr>
                      <td className="fs14 fw-normal" style={{ width: "25%" }}>
                        Check-Out Time
                      </td>
                      <td className="fs14 fw500">
                        {detailData?.check_out_date &&
                          DateService.dateFormat(detailData?.check_out_date)} {detailData?.check_out_minutes}
                      </td>
                    </tr>
                    <tr>
                      <td className="fs14 fw-normal" style={{ width: "25%" }}>
                        Check-Out Mode
                      </td>
                      <td className="fs14 fw500">
                        {detailData?.check_out_mode || "-"}
                      </td>
                    </tr>
                    <tr>
                      <td className="fs14 fw-normal" style={{ width: "25%" }}>
                        IP Address
                      </td>
                      <td className="fs14 fw500">
                        {detailData?.check_out_ip || "-"}
                      </td>
                    </tr>
                    <tr>
                      <td className="fs14 fw-normal" style={{ width: "25%" }}>
                        Location
                      </td>
                      <td className="fs14 fw500">
                        {detailData?.check_out_lat && detailData?.check_out_long ?
                          <a
                            href={`https://www.google.com/maps/search/${detailData?.check_out_lat},${detailData?.check_out_long}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-primary"
                          >view </a>
                          : "-"}
                      </td>
                    </tr>
                    <tr>
                      <td className="fs14 fw-normal" style={{ width: "25%" }}>
                        Updated By 
                      </td>
                      <td className="fs14 fw500">
                        {detailData?.check_out_by || "-"}
                      </td>
                    </tr>
                    <tr>
                      <td className="fs14 fw-normal" style={{ width: "25%" }}>
                        Notes
                      </td>
                      <td className="fs14 fw500">
                        {detailData?.checkout_note || "-"}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="col-md-3 text-center">
                <div style={{ height: "120px", width: "120px", margin: "0 auto" }}>
                  {detailData?.check_out_photo_link ? (
                    <img
                      src={detailData?.check_out_photo_link}
                      className="img-fluid"
                      alt="Check-out location "
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        borderRadius: "4px"
                      }}
                    />
                  ) : (
                    <img
                      src="https://t4.ftcdn.net/jpg/01/86/29/31/360_F_186293166_P4yk3uXQBDapbDFlR17ivpM6B1ux0fHG.jpg"
                      className="img-fluid"
                      alt="No check-out photo available"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        borderRadius: "4px"
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
        </div>
    );
};

export default AttendenceSummaryDetailModal;